<template>
  <div>
    <div class="cases-top">
      <div class="cases-top-left">
        <div class="cases-tabs">
          <router-link to="/cases">
            <div class="cases-tab cases-tab1" :class="isArchived ? '' : 'active'">Aktivni predmeti</div>
          </router-link>
          <router-link to="/archived-cases">
            <div class="cases-tab cases-tab2" :class="isArchived ? 'active' : ''">Arhivirani</div>
          </router-link>


        </div>
        <!-- <div class="period"> -->
        <div v-if="!isArchived" class="picker-wrapper">
          <!-- <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="auto" v-if="!isArchived">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" label="Odaberite period" append-icon="mdi-calendar" v-bind="attrs"
                @click="menu1 = !menu1" v-on="on" class="case-date-picker"></v-text-field>
            </template>
            <v-date-picker locale="hr" v-model="date_range" range no-title></v-date-picker>
          </v-menu> -->
          <!-- Odaberi period<svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="26"
              viewBox="0 0 26 26"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M13.761 16.382c0-1.088.885-1.973 1.973-1.973h2.319c1.088 0 1.973.885 1.973 1.973V18.7a1.975 1.975 0 0 1-1.973 1.973h-2.319a1.975 1.975 0 0 1-1.973-1.973zm1.973 2.318h2.319v-2.318h-2.319zm3.305-8.582a.986.986 0 1 1 0 1.973.986.986 0 0 1 0-1.973zm-4.291 0a.986.986 0 1 1 0 1.973.986.986 0 0 1 0-1.973zm8.533 7.004V6.665a1.975 1.975 0 0 0-1.973-1.973h-1.282v.986a.986.986 0 1 1-1.973 0v-.986h-4.489v.986a.986.986 0 0 1-1.973 0v-.986H7.152v.986a.986.986 0 0 1-1.973 0v-.986H3.946a1.975 1.975 0 0 0-1.973 1.973v15.39c0 1.087.885 1.972 1.973 1.972h17.362a1.975 1.975 0 0 0 1.973-1.973.986.986 0 0 1 1.973 0A3.95 3.95 0 0 1 21.308 26H3.946A3.95 3.95 0 0 1 0 22.054V6.664A3.95 3.95 0 0 1 3.946 2.72h1.233v-.986a.986.986 0 1 1 1.973 0v.986h4.44v-.986a.986.986 0 1 1 1.972 0v.986h4.489v-.986a.986.986 0 1 1 1.973 0v.986h1.282a3.95 3.95 0 0 1 3.946 3.946v10.457a.986.986 0 1 1-1.973 0zM6.165 18.7a.987.987 0 1 1 0 1.973.987.987 0 0 1 0-1.973zm0-8.582a.987.987 0 1 1 0 1.973.987.987 0 0 1 0-1.973zm0 4.29a.987.987 0 1 1 0 1.974.987.987 0 0 1 0-1.973zm4.292 0a.986.986 0 1 1 0 1.974.986.986 0 0 1 0-1.973zm0-4.29a.986.986 0 1 1 0 1.973.986.986 0 0 1 0-1.973zm0 8.582a.986.986 0 1 1 0 1.973.986.986 0 0 1 0-1.973z"
                  />
                </g>
              </g>
            </svg> -->
          <!-- </div> -->
          <CustomDropdown :id="'drop_clanovi'" :additional_classes="['phase']" v-model="selektirana_osoba" :drop_items="all_users" init_text="Odaberi člana tima" />
          <CustomDropdown :id="'drop_faze'" class="wider" :additional_classes="['phase']" v-model="selektirana_faza" :drop_items="faze_postupka" init_text="Odaberi fazu" />
          <CustomDropdown :id="'drop_postupci'" class="wider" :additional_classes="['phase']" v-model="selektirani_postupak" :drop_items="vrste_postupka" init_text="Odaberi vrstu" />
        </div>
        <div class="archived-destroyed-wrapper"
          v-if="isArchived && all_casses_data.find(cs => cs.is_destroyed == true)">
          <div v-if="!isDestroyed" class="archived-destroyed-element unisti" @click="isDestroyed = true; getCases()">
            Prikaži uništene</div>
          <div v-if="isDestroyed" class="archived-destroyed-element sve" @click="isDestroyed = false; getCases()">
            Prikaži sve</div>
        </div>
      </div>
      <div class="cases-top-right">
        <router-link to="/novi-predmet/" class="add-case">Unesi novi predmet
          <div class="add-plus">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
              <g>
                <g>
                  <path fill="#fff"
                    d="M10.346 7.733H7.741v2.606a1.737 1.737 0 1 1-3.474 0V7.733H1.662a1.737 1.737 0 0 1 0-3.476h2.605V1.651a1.737 1.737 0 1 1 3.474 0v2.606h2.605a1.737 1.737 0 0 1 0 3.476z" />
                </g>
              </g>
            </svg>
          </div>
        </router-link>
      </div>
    </div>
    <!-- <div class="page-nav">
      <div class="page-nav-prev" v-if="!isFirstPage">
        <img src="@/assets/img/ar-prev.svg" /><button
          @click="setPage(curr_page - 1)"
        >
          prethodna
        </button>
      </div>
      <div class="page-nav-next" v-if="!isLastPage">
        <button @click="setPage(curr_page + 1)">sljedeća</button
        ><img src="@/assets/img/ar-next.svg" />
      </div>
      <div class="page-nav-no">
        Stranica
        <div class="page-nav-number">
          <select v-model="curr_page">
            <option
              v-for="(str, key) in popis_brojeva_stranica"
              :key="key"
              :value="str"
            >
              {{ str }}
            </option>
          </select>
        </div>
      </div>
      <div class="page-nav-no">
        Broj redova po stranici:
        <div class="page-nav-number">
          <select v-model="broj_predmeta">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
        </div>
      </div>
    </div> -->

    <div class="testtable">
      <table class="responstable" v-if="data_loaded" :key="rfrsh_predmet">
        <tr>
          <th>
            <div @click="enableSearch()" class="search-year-wrapper" v-if="!active_filter">{{computedYear}}
              <div class="edit-case-name add-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                <path d="M4.42698 8.12555e-07C1.98926 8.12555e-07 0 1.98926 0 4.42698C0 6.86471 1.98926 8.85397 4.42698 8.85397C5.42631 8.85397 6.34705 8.516 7.0895 7.95355L9.94879 10.8122C10.1019 10.9718 10.3294 11.036 10.5434 10.9802C10.7573 10.9245 10.9244 10.7573 10.9802 10.5434C11.036 10.3294 10.9718 10.1019 10.8122 9.94879L7.95355 7.0895C8.516 6.34705 8.85397 5.42631 8.85397 4.42698C8.85397 1.98926 6.86471 0 4.42699 0L4.42698 8.12555e-07ZM4.42698 1.22124C6.2047 1.22124 7.63273 2.64927 7.63273 4.42698C7.63273 5.28054 7.30118 6.05141 6.76212 6.62438C6.70965 6.66236 6.66355 6.70846 6.62557 6.76093C6.05248 7.30068 5.28115 7.63273 4.42698 7.63273C2.64926 7.63273 1.22124 6.2047 1.22124 4.42698C1.22124 2.64927 2.64926 1.22124 4.42698 1.22124V1.22124Z" fill="#606076"/>
                </svg>
              </div>
            </div>
            <div v-else class="input-element"><span>Traži:&nbsp;</span><input @keydown.esc="search_year = ''" id="year-search" @keypress="textChange" v-model="search_year" @blur="active_filter = false" type="text"/></div>
          </th>
          <!-- <th>BR.
          </th> -->
          <th data-th="Detalji predmeta"><span>Datum</span><div class="downarrow"></div>
          </th>
          <th>Stranka<div class="downarrow"></div>
          </th>
          <th>Protustranka<div class="downarrow"></div>
          </th>
          <th>Naziv predmeta<div class="downarrow"></div>
          </th>
          <th>Članovi tima<div class="downarrow"></div>
          </th>
          <th>Faza<div class="downarrow"></div>
          </th>
          <th>Vrsta<div class="downarrow"></div>
          </th>
          <th v-if="isArchived">Uništen
          </th>
        </tr>
        <tr v-for="(single_case, key) in all_casses_data" :key="key">
          <td>
            <router-link :to="base_url + single_case.group_url + '/'">
              <b>{{ single_case.broj_predmeta }}</b>
            </router-link>
          </td>
          <td>{{ single_case.is_destroyed ? switchDate(single_case.datum_unistenja) : single_case.is_archived ? switchDate(single_case.datum_arhiviranja) : switchDate(single_case.datum_pocetka) }}</td>
          <td>
            <a href="#" v-if="
              single_case.prav_connect_stranka.length == 0 &&
              single_case.connect_fiz_stranka.length == 0
            ">N/A</a>
            <router-link :to="
              '/osobe/prav/' +
              single_case.prav_connect_stranka[0].pravna_osoba.uid
            " v-if="single_case.prav_connect_stranka.length > 0">{{
    single_case.prav_connect_stranka[0].pravna_osoba.ime
}}
            </router-link>
            <router-link :to="
              '/osobe/fiz/' +
              single_case.connect_fiz_stranka[0].fizicka_osoba.uid
            " v-if="
  single_case.connect_fiz_stranka.length > 0 &&
  single_case.prav_connect_stranka.length == 0
">
              {{ single_case.connect_fiz_stranka[0].fizicka_osoba.ime }}
              {{
                  single_case.connect_fiz_stranka[0].fizicka_osoba.prezime
              }}</router-link>

            <v-tooltip right v-if="
              single_case.connect_fiz_stranka.length +
              single_case.prav_connect_stranka.length >
              1
            ">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(stranka, key) in single_case.connect_fiz_stranka" :key="'1' + key">{{ stranka.fizicka_osoba.ime
              }} {{
    stranka.fizicka_osoba.prezime
}}</p>
              <p v-for="(stranka, key) in single_case.prav_connect_stranka" :key="'2' + key">{{ stranka.pravna_osoba.ime
              }}</p>
            </v-tooltip>
          </td>
          <td>
            <a href="#" v-if="
              single_case.prav_connect_protustranka.length == 0 &&
              single_case.connect_fiz_protustranka.length == 0
            ">N/A</a>
            <router-link :to="
              '/osobe/prav/' +
              single_case.prav_connect_protustranka[0].pravna_osoba.uid
            " v-if="single_case.prav_connect_protustranka.length > 0">{{
    single_case.prav_connect_protustranka[0].pravna_osoba.ime
}}
            </router-link>
            <router-link :to="
              '/osobe/fiz/' +
              single_case.connect_fiz_protustranka[0].fizicka_osoba.uid
            " v-if="
  single_case.connect_fiz_protustranka.length > 0 &&
  single_case.prav_connect_protustranka.length == 0
">
              {{ single_case.connect_fiz_protustranka[0].fizicka_osoba.ime }}
              {{
                  single_case.connect_fiz_protustranka[0].fizicka_osoba.prezime
              }}</router-link>

            <v-tooltip right v-if="
              single_case.connect_fiz_protustranka.length +
              single_case.prav_connect_protustranka.length >
              1
            ">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(stranka, key) in single_case.connect_fiz_protustranka" :key="'3' + key">{{
                  stranka.fizicka_osoba.ime
              }} {{
    stranka.fizicka_osoba.prezime
}}</p>
              <p v-for="(stranka, key) in single_case.prav_connect_protustranka" :key="'4' + key">{{
                  stranka.pravna_osoba.ime
              }}</p>
            </v-tooltip>
          </td>
          <td>
            <router-link :to="base_url + single_case.group_url + '/'">{{
                single_case.ime_predmeta
            }}</router-link>
          </td>
          <td>
            <a href="#" v-if="single_case.predmet_odvjetnik_connector.length == 0">N/A</a>
            <router-link :to="
              single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2) != null ?  '/osobe/law/' +single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2).odvjetnik.uid : '/osobe/law/' +single_case.predmet_odvjetnik_connector[0].odvjetnik.uid
            " v-else>{{ single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2) != null ?  single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2).odvjetnik.ime : single_case.predmet_odvjetnik_connector[0].odvjetnik.ime}}
              {{
                single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2) != null ? single_case.predmet_odvjetnik_connector.find((od)=>od.status_odvjetnik_predmet.id_status == 2).odvjetnik.prezime : single_case.predmet_odvjetnik_connector[0].odvjetnik.prezime
              }}</router-link>
            <v-tooltip right v-if="
              single_case.predmet_odvjetnik_connector.length > 1
            ">
              <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Right
                  </v-btn> -->
                <img v-bind="attrs" v-on="on" class="more-dots" src="@/assets/img/more.svg" />
              </template>
              <p v-for="(stranka, key) in single_case.predmet_odvjetnik_connector" :key="key">{{ stranka.odvjetnik.ime
              }} {{
    stranka.odvjetnik.prezime
}}</p>
            </v-tooltip>
          </td>
          <td>{{ single_case.faza_postupka.naziv }}</td>
          <td>{{ single_case.spis.length>0 && single_case.spis[0].postupak.naziv }}</td>
          <td v-if="isArchived">{{ single_case.is_destroyed ? "DA" : 'NE' }}</td>
        </tr>
      </table>
      <div v-else class="paznja-spinner">
        <svg class="dot-spin" viewBox="0 0 50 50">
          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
      </div>
    </div>

    <div class="cases-pagination">
      <div class="cases-pagination-left">
        <div class="pagin-wrapp page-nav" v-if="popis_brojeva_stranica.length>1">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="popis_brojeva_stranica.length>1">
          <div :class="{ 'curr-page': curr_page == popis_brojeva_stranica.length }"
            @click="setPage(popis_brojeva_stranica.length)">
            {{ popis_brojeva_stranica.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          
        </div>
        <!-- <img style="width:16rem;" src="@/assets/img/paginacija2.svg"> -->
      </div>
      <div class="cases-number">
        <span>Ukupan broj predmeta: <b>{{total_case_number}}</b></span> 
        <div class="vertical-divider"></div>
        <div class="generiraj-rocisnik-button" @click="openReport()">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none"><path d="M5.24463 13.7815L8.23776 9.89137L11.652 12.5733L14.581 8.79297" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><circle cx="17.9954" cy="3.20027" r="1.9222" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle><path d="M12.9243 2.12024H5.65655C2.64511 2.12024 0.777832 4.25296 0.777832 7.2644V15.3468C0.777832 18.3582 2.6085 20.4818 5.65655 20.4818H14.2607C17.2721 20.4818 19.1394 18.3582 19.1394 15.3468V8.30788" stroke="#2B2B41" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          <span>Izvještaj</span>
        </div>
      </div>
      <div class="cases-pagination-right">
        Broj redova po stranici
        <div class="broj-redova">
          <select id="search-group" v-model="broj_predmeta">
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
          </select>
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11">
            <g>
              <g>
                <path fill="#3326ae"
                  d="M.204 3.503a.754.754 0 0 0 .572.264c.18 0 .354-.065.506-.196l1.816-1.828L4.92 3.571c.142.142.33.22.53.22.202 0 .39-.078.533-.22a.76.76 0 0 0 0-1.065L3.632.14A.748.748 0 0 0 3.1-.077c-.2 0-.388.077-.53.22L.203 2.522a.754.754 0 0 0 0 .98z" />
              </g>
              <g>
                <path fill="#3326ae"
                  d="M6.026 7.411a.758.758 0 0 0-1.083-.067L3.12 9.17 1.291 7.343a.75.75 0 0 0-.532-.22.75.75 0 0 0-.534.221.757.757 0 0 0 0 1.065l2.36 2.364a.752.752 0 0 0 .533.219c.201 0 .39-.078.534-.22l2.374-2.38a.752.752 0 0 0 0-.98z" />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "@/services/auth";
import GroupList from "@/components/generalComponents/GroupList";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import share from "@/apiCallers/sharepoint";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import person from "@/apiCallers/person";
import moment from "moment";
import $ from 'jquery';
import gsap from "gsap";

export default {
  components: { GroupList, CustomDropdown },
  data() {
    return {
      date_range: [],
      accessToken: "",
      dohvaceni_predmeti: [],
      prav_protustranke: [],
      prav_stranke: [],
      fiz_stranke: [],
      fiz_protustranke: [],
      all_casses_data: [],
      base_url: "/case/",

      rfrsh_predmet: 1,

      // Paginacija start
      popis_brojeva_stranica: [],
      curr_page: 1,
      broj_predmeta: 5,
      left_dots_visible: false,
      right_dots_visible: false,
      //Paginacija end

      //filteri START
      vrste_postupka: [],
      selektirani_postupak: 0,
      selektirana_osoba:0,
      faze_postupka: [],
      selektirana_faza: 0,
      isArchived: false,
      //filteri END
      all_users:[],
      odvjetnici: [],
      data_loaded: false,
      menu1: false,
      isDestroyed: false,
      active_filter: false,
      search_year:'',
      timeout: setTimeout(function () { }, 0),
      total_case_number:0,
      lawyer_id:null,
    };
  },
  async created() {
    if (this.$route.name === "ArchivedCases") {
      this.isArchived = true;
      this.base_url = "/archived-case/"
    }
    this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
    let lawyer_id = await person.getSelf(this.accessToken);
    await predmet_hand.getAllOdvjetniciShort().then((resp) => {
      let logged_person = resp.data.find((us)=>us.id == lawyer_id.data.uid)
      if(logged_person){
        this.all_users = resp.data.filter(odvj=>odvj != logged_person);
        this.all_users.unshift(logged_person);
        this.all_users.unshift({id:0, naziv: 'Odaberi člana tima'})
      }
    });
    if(this.$store.state.view_cases_by_logged_person && lawyer_id.data.uid){
      this.selektirana_osoba = lawyer_id.data.uid;
      this.$store.state.view_cases_by_logged_person = false;
    }
    console.log(this.isArchived, " Arhiviran?")
    this.getCases();
    predmet_hand.getAllFilteri().then((response) => {
      this.vrste_postupka = response.data.vrste_postupka
      this.vrste_postupka.unshift({id:0, naziv: 'Odaberi vrstu'})
      this.faze_postupka = response.data.faze_postupka
      this.faze_postupka.unshift({id:0, naziv: 'Odaberi fazu'})
    });
    //  this.addNewGroup();
    // console.log(this.accessToken)
  },
  computed: {
    computedYear(){
      return this.search_year == '' ? 'BR.' : 'Filter: '+this.search_year;
    },
    getLeftRightPages() {
      // Init values
      let return_pages = []
      this.right_dots_visible = false;
      this.left_dots_visible = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page;
      if(this.curr_page == this.popis_brojeva_stranica.length)
        left_end = this.curr_page-1;
      if (this.curr_page > 3) {
        left_start = this.curr_page - 1;
        this.left_dots_visible = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page + 1;
      if (right_start < this.popis_brojeva_stranica.length)
        return_pages.push(right_start);
      if(right_start < this.popis_brojeva_stranica.length-1)
      this.right_dots_visible = true;
      return return_pages
    },
    isFirstPage() {
      return this.curr_page == 1;
    },
    isLastPage() {
      return (
        this.curr_page ==
        this.popis_brojeva_stranica[this.popis_brojeva_stranica.length - 1]
      );
    },
    dateRangeText() {
      var ret_date_string = [];
      this.date_range.forEach((p) => {
        ret_date_string.push(moment(p).format("l"));
      });
      return ret_date_string.join(" ~ ");
    },
  },
  watch: {
    curr_page: function () {
      this.getNewData();
    },

    broj_predmeta: function () {
      this.getNewData();
    },
    date_range: function () {
      this.getNewData();
    },

    selektirana_faza: function () {
      this.curr_page = 1;
      this.getNewData();
    },
    selektirani_postupak: function () {
      this.curr_page = 1;
      this.getNewData();
    },
    selektirana_osoba: function () {
      this.curr_page = 1;
      this.getNewData();
    },
    search_year: function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.curr_page = 1;
        console.log(this.search_year);
        this.getNewData();
      }, 1000);
    }
  },
  methods: {
    textChange($event) {
      let res = $event.key.match(/^[0-9]*[-]?[0-9]*$/g)
      if(!res){
        event.preventDefault();
        return false;
      }
    },
    async openReport(){
      await predmet_hand
        .getAll(
          this.accessToken,
          this.curr_page,
          this.selektirani_postupak,
          this.selektirana_faza,
          this.total_case_number,
          null,
          null,
          this.isArchived,
          this.isDestroyed,
          this.search_year,
          this.selektirana_osoba,
        )
        .then((response) => {
          console.log(response.data.full_case_list);
          this.$store.state.predmeti_report_data.all_predmeti = response.data.full_case_list;
          this.$router.push('/predmeti-report');
          this.$store.state.predmeti_report_data.naslov =  this.search_year.length == 4 && !this.search_year.includes('-') ? 'Pregled predmeta u '+this.search_year+'. godini.' : 'Pregled predmeta';
        });
    },
    async getCases() {
      this.data_loaded = false;
      predmet_hand
        .getAll(
          this.accessToken,
          this.curr_page,
          this.selektirani_postupak,
          this.selektirana_faza,
          this.broj_predmeta,
          null,
          null,
          this.isArchived,
          this.isDestroyed,
          '',
          this.selektirana_osoba,
        )
        .then((response) => {
          console.log(response.data.full_case_list);
          this.all_casses_data = response.data.full_case_list;
          this.data_loaded = true;
          this.popis_brojeva_stranica = response.data.popis_brojeva_stranica;
          this.total_case_number = response.data.broj_redova_predmeta;
          console.log(response.data);
          gsap.to(".responstable", 0.5, { opacity: 1, x: 0 });
        });
    },
    async getNewData() {
      this.accessToken = await auth.acquireToken(process.env.GRAPH_SCOPES);
      var start_date = null;
      var end_date = null;

      if (this.date_range.length > 0) {
        start_date = this.date_range[0];
        if (this.date_range.length > 1) {
          end_date = this.date_range[1];
        }
      }
      predmet_hand
        .getAll(
          this.accessToken,
          this.curr_page,
          this.selektirani_postupak,
          this.selektirana_faza,
          this.broj_predmeta,
          start_date,
          end_date,
          this.isArchived,
          this.isDestroyed,
          this.search_year,
          this.selektirana_osoba,
        )
        .then((response) => {
          console.log(response.data.full_case_list);
          this.all_casses_data = response.data.full_case_list;
          this.data_loaded = true;
          this.popis_brojeva_stranica = response.data.popis_brojeva_stranica;
          this.total_case_number = response.data.broj_redova_predmeta;
          //table return animation
          gsap.to(".responstable", 0.5, { opacity: 1, x: 0 });
        });
    },
    setPage(str) {
      console.log("Odabrana je stranica " + str);
      this.curr_page = parseInt(str);
      console.log(this.curr_page);

      //table initial animation
      gsap.to(".responstable", 0.5, { opacity: 0, x: -10 });
    },
    switchDate(inData) {
      return inData == null ? '' : moment(inData.toString()).format("l");
    },
    getYear(inData) {
      return moment(inData.toString()).format("YYYY");
    },
    fullLogout() {
      auth.clearLocal();
      auth.logout();
      this.$router.push({ path: "/login" });
    },

    addNewGroup() {
      var tempGroup = {
        description: "2021-213",
        displayName:
          "2021-213 GOLUBOVECKI KAMENOLOMI D.O.O. - CT CONSTRUCTION MANAGEMENT D.O.O",
        groupTypes: ["Unified"],
        mailEnabled: true,
        visibility: "Hiddenmembership",
        mailNickname: "2021-213",
        securityEnabled: false,
      };
      var resp = null;
      share.addNewGroup(this.accessToken, tempGroup).then((response) => {
        console.log(response);
        resp = response;
      });
    },
    enableSearch(){
      this.active_filter = true;
      setTimeout(() => {
        $("#year-search").focus();
      }, 100);
    }
  },
  mounted() {
    // this.addNewGroup();

    //paginacija
    this.$store.state.paginacija.title = "Upravljanje predmetima";
    document.body.classList.add("predmeti-body");
  },
  destroyed() {
    document.body.classList.remove("predmeti-body");
  },
};
</script>

<style>
</style>